import { Local } from '@core/models/local.model';
import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { OwnerShipService } from '../ownership.services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatTableDataSource, MatDialogRef, MatDialog } from '@angular/material';
import { Location } from '@angular/common';
import { AppMapDialogComponent } from '@core/components/map-dialog/map-dialog.component';

@Component({
    selector   : 'app-ownership-detail',
    templateUrl: './ownership-detail.component.html',
    styleUrls  : ['./ownership-detail.component.scss']
})

export class OwnerShipDetailComponent implements OnInit
{
    mapDialogRef: MatDialogRef<AppMapDialogComponent>;

    private _unsubscribeAll: Subject<any>;
    local: Local;
    displayedColumns: string[] = ['type', 'name', 'status', 'id'];
    filesLocal: any [] = [];
    dataSource1 = new MatTableDataSource();
    dataSource2 = new MatTableDataSource();

    public config: SwiperConfigInterface = {
        direction: 'horizontal',
        slidesPerView: 1,
        keyboard: true,
        mousewheel: false,
        scrollbar: false,
        navigation: false,
        pagination: true,

     };

    constructor(private _ownerShipService: OwnerShipService, public dialog: MatDialog,
        private _location: Location) {

        this._unsubscribeAll = new Subject();
        this.local = new Local();

    }

    ngOnInit(){
        this._ownerShipService.localOnChanged.pipe(takeUntil(this._unsubscribeAll))
        .subscribe( local => {
            this.local = local;
            this.filesLocal =  this.getFilesLocal(this.local.attachments);
            this.dataSource1.data = this.getDocs(this.local.attachments);
            this.dataSource2.data = this.getVoucher(this.local.attachments);
        });
    }

    getFilesLocal(attachments: any []) {
        const files  = attachments.filter(item =>  item.type === 'fachada' || item.type === 'interior' || item.type === 'entorno');
        return files;
    }


    getDocs(attachments: any []) {
        const files  = attachments.filter(item => item.type === 'dni' || item.type === 'hr' || item.type === 'pu' || item.type === 'partida'
            || item.type === 'arbitrios'
            || item.type === 'light'
            || item.type === 'water'
            || item.type === 'certificate'
            || item.type === 'other'
            );
        return files;
    }

    getVoucher(attachments: any []) {
        return  attachments.filter(item =>  item.type === 'voucher');
    }
    StrTypeDoc(type): string {
        let _r = '';
        switch (type) {
            case 'hr':
                _r = 'Hoja resumen';
                break;

            case 'pu':
                _r = 'Predio urbano';
                break;

            case 'light':
                _r = 'Luz';
                break;

            case 'water':
                _r = 'Agua';
                break;

            case 'certificate':
                _r = 'Certificado';
                break;

            case 'other':
                _r = 'Otros';
                break;
            default:
                _r = type;
            break;
        }
        return _r;
    }


    isBack(){
        this._location.back();
    }

    viewMap() {

        this.mapDialogRef = this.dialog.open(AppMapDialogComponent, {
            disableClose: false
        });

        this.mapDialogRef.componentInstance.latitude = Number(this.local.latitud);
        this.mapDialogRef.componentInstance.longitude = Number(this.local.longitud);

        this.mapDialogRef.afterClosed().subscribe(result => {

            this.mapDialogRef = null;
        });

    }
}

